/**
 * Run-time formatting helpers. Pure functions - covered by unit tests.
 */

/** Formats milliseconds as `MM:SS.mmm`, e.g. `00:42.381`. */
export function formatTime(ms: number): string {
  const safe = Number.isFinite(ms) ? Math.max(0, Math.round(ms)) : 0;
  const minutes = Math.floor(safe / 60000);
  const seconds = Math.floor((safe % 60000) / 1000);
  const millis = safe % 1000;
  return (
    String(minutes).padStart(2, '0') +
    ':' +
    String(seconds).padStart(2, '0') +
    '.' +
    String(millis).padStart(3, '0')
  );
}

/** Formats a delta against the previous PB, e.g. `-0.483` / `+1.217`. */
export function formatDelta(deltaMs: number): string {
  const rounded = Math.round(deltaMs);
  const sign = rounded < 0 ? '-' : '+';
  const abs = Math.abs(rounded);
  const seconds = Math.floor(abs / 1000);
  const millis = abs % 1000;
  return `${sign}${seconds}.${String(millis).padStart(3, '0')}`;
}

/** Short `SS.mmm` form used in the split table. */
export function formatSplit(ms: number): string {
  const safe = Math.max(0, Math.round(ms));
  const minutes = Math.floor(safe / 60000);
  const seconds = Math.floor((safe % 60000) / 1000);
  const millis = safe % 1000;
  if (minutes > 0) {
    return `${minutes}:${String(seconds).padStart(2, '0')}.${String(millis).padStart(3, '0')}`;
  }
  return `${seconds}.${String(millis).padStart(3, '0')}`;
}

/**
 * Metres per second as km/h, to one decimal - the unit Kimmo's speed is
 * reported in. One decimal on purpose: whole km/h hides the moment a jump or a
 * clipped doorway costs you something, and two make the readout twitch.
 */
export function formatSpeedKmh(metersPerSecond: number): string {
  const safe = Number.isFinite(metersPerSecond) ? Math.max(0, metersPerSecond) : 0;
  return `${(safe * 3.6).toFixed(1)} km/h`;
}
